import React from "react";
import "./styles.css";

export default function TemperatureUnit(props) {
  return (
    <div>
      <span className="temperature" id="temperature">
        {Math.round(props.celsius)}
      </span>
      <span className="units">℃ </span>
    </div>
  );
}
